import React, { useEffect, useState } from 'react';
import { CacheProvider } from '@emotion/react';
import Link from '@mui/material/Link';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { addDataPosition, appendStyleSheet, getEndpoint, getID, getMUICache, getUrl, getImageSize, getImageUrl, GetFallBackImage, isImageSizeBlank, fetchAnchorValue, isCSR, insertAdSlot } from '../../../common/utils';

import { I_CDSListingItemTO } from '@interfaces/ICDSListingResponseTO';
import "./QuickViewThree.css";
import { PAGEBUILDER_URLS } from '../../Common/Constant';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { IconButton } from '@mui/material';
import bcrypt from 'bcryptjs-react';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages,PreloadViewportImages, ImageLoader} from '../../../components/IntersectionObserver/imageComponent';
// import { isMobile, isDesktop } from "react-device-detect";

QuickViewThree.version = 1000;

QuickViewThree.lang = 'en';
QuickViewThree.langs = [
  'en'
];
QuickViewThree.setLang = (lang: any) => {
  QuickViewThree.lang = lang;
}

Object.defineProperty(QuickViewThree, 'name', {
  writable: true,
  value: 'QuickViewThree'
});

const NextArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", right: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>

      <IconButton className='CustomPrevArrow'>
        <ArrowForwardIosOutlinedIcon />
      </IconButton>

    </div>
  );
}

const PrevArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", left: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>
      {/* <KeyboardArrowLeftIcon fontSize='medium' /> */}
      <IconButton className='CustomNextArrow'>
        <ArrowBackIosNewOutlinedIcon />
      </IconButton>
    </div>
  );
}

export function QuickViewThree(props: any) {
  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();

  useEffect(()=>{
    EagerLoadImages()
},[]);

  const { anchorLinksValue } = props;

  let styles = require("./QuickViewThree.css");
  const [msid, setMsid] = useState<any>('');
  const [items, setItems] = useState<I_CDSListingItemTO[]>([]);
  appendStyleSheet("QuickViewThree", styles);

  const endpoint = getEndpoint(props);

  // Preload images when items are available
  // const preloadSet = useRef(new Set<string>()); // Track preloaded image URLs
  // useEffect(() => {
  //   if (items.length > 0) {
  //     items.forEach(item => {
  //       const imageUrl = getImageUrl(item.id, getImageSize(item.imageid), 265, 199, "", false, props.CONSTANTS);

  //       if (!preloadSet.current.has(imageUrl)) {
  //         const link = document.createElement('link');
  //         link.rel = 'preload';
  //         link.href = imageUrl;
  //         link.as = 'image';
  //         document.head.appendChild(link);
  //         preloadSet.current.add(imageUrl); 
  //       }
  //     });
  //   }
  // }, [items, props.CONSTANTS]);

  // Preload images when items are available

  // const [clientDevice, setClientDevice] = useState({ isDesktop: false, isMobile: false });
  // useEffect(() => {
  //     setClientDevice({ isDesktop, isMobile });
  // }, []);

  // useEffect(() => {
  //   if (clientDevice.isDesktop && props.bodyAdScript) {
  //       const adContainer = document.getElementById("ad-container");
  //       if (adContainer) {
  //           const script = document.createElement("script");
  //           script.async = true;
  //           script.innerHTML = props.bodyAdScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
  //           adContainer.appendChild(script);
  //       }
  //   }
  //   if (clientDevice.isMobile && props.bodyAdMobileScript) {
  //       const adContainer = document.getElementById("ad-container");
  //       if (adContainer) {
  //           const script = document.createElement("script");
  //           script.async = true;
  //           script.innerHTML = props.bodyAdMobileScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
  //           adContainer.appendChild(script);
  //       }
  //   }
  // }, [clientDevice.isDesktop,clientDevice.isMobile, props.bodyAdScript, props.bodyAdMobileScript]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gpEditor) {

        window.gpEditor.editor.on('component:selected', (component: any) => {
            if (component && component.attributes && component.attributes.type === "Quick View Three") {
                setTimeout(() => {
                    const trait = component.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                    if (trait && trait.el) {
                        // Show trait element if showAdSlot is true, hide otherwise
                        trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                    }
                }, 200);
            }
        });

        const selected = window.gpEditor.getSelected();
        if (selected) {
            const trait = selected.getTraits().find((tr: any) => tr.get('id') === "deviceType");
            if (trait && trait.el) {
                // Show trait element if showAdSlot is true, hide otherwise
                trait.el.style.display = props.showAdSlot ? 'block' : 'none';
            }
        }
    }
  }, [endpoint, props.showAdSlot, props.adSize]);

  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, [props.MSID, endpoint, props.showAdSlot]);

  const setItemsObj = (response: any) => {
    setItems(response.items)
  }

  if (endpoint.isSSR && endpoint.SSRDataObj && (!items || !items.length) && endpoint.SSRDataObj.pg != null
    && endpoint.SSRDataObj.pg.tr != null && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length != 0) {
    setItemsObj(endpoint.SSRDataObj);
  }

  const fetchComponentData = () => {
    getData(getUrl(props));
  }

  const getData = (url: string) => {
    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };

    fetch(url, { headers: headers })
      .then((response) => response.json())
      .then(response => {
        setItemsObj(response);
      })
      .catch(err => {
        //console.log(err);
      });
  }

  const carouselRef = React.useRef(null);

  const getRenderPart = () => {
    if (msid && props.msid && msid != props.msid) {
      props.queryParams.msid = props.msid;
      setMsid(props.queryParams.msid);
      getData(getUrl(props));
    }

    if (!items || !items.length) {
      return "";
    }

    let i_scrollMode = true;
    if (props.scroll == 'manual') {
      i_scrollMode = false;
    }

    let componentID = getID(props.data);

    let blockHeading: any = '';
    if (props.mainHeading) {
      blockHeading = <div className="ThemeThreeHeroNavHeadingWrap">
        <p className='ThemeThreeCommonSubHeading'>INSTRUCTOR</p>
        <h3 className='ThemeThreeHeroNavHeading themeThreeCommonComponentsHeading'><Link href={props.mainHeadingHref} style={{ color: props.mainHeadingColor }} target={fetchAnchorValue(anchorLinksValue, props.mainHeadingHref)} >{props.mainHeading}</Link></h3>
      </div>;
    }


    const Carouselsettings = {
      infinite: false,//items.length > 1 ? true : false,
      speed: 500,
      autoplay: i_scrollMode,
      slidesToShow: 4,
      slidesToScroll: parseInt(props.scrollCount, 10),
      initialSlide: 0,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      swipeToSlide: true,
      variableWidth: true,
      dots: true,
      arrows: false,
      className: 'ThemeThreeQuickView',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: props.scrollCount,
            variableWidth: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: props.scrollCount,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,

          }
        }
      ]
    };


    let bodySnippet: any;
    if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
      bodySnippet = `<div className=\'ThemeThreeWebQuickViewCardWrap\' style="width: 265px;text-align: center;">Ad Slot<br>265 X 287</div>`
    }

    else if (isCSR()) {
      // console.log("Only CSR");
      // if (clientDevice.isDesktop) {
      //     bodySnippet = `<div id="ad-container">${props.bodyAdScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
      // } else if (clientDevice.isMobile) {
      //     bodySnippet = `<div id="ad-container">${props.bodyAdMobileScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
      // }
      bodySnippet = props?.data?.attributes?.adConfigurations;
    }
    else {
        console.log("Only SSR");
        // bodySnippet = `<div></div>`;
        bodySnippet = props?.data?.attributes?.adConfigurations;
    }

    return <CacheProvider value={getMUICache()}>
      <div id={componentID}>
        <div className='commoncontainer'>
          {blockHeading}

          <div >
            <Slider {...Carouselsettings} ref={carouselRef}>
              {items &&
                items.map((itemObj, index) => {
                  if (props.showAdSlot) {
                    if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
                      if (props.adNetwork === "google" && index === 2) {
                        return <div key={'0_' + index} className='ThemeThreeWebQuickViewCardWrap' dangerouslySetInnerHTML={{ __html: addDataPosition(bodySnippet, index) }}></div>
                      } else if (props.adNeThreerk === "can") {
                        if ((index + 1) % 4 === 3) {
                          return <div key={'0_' + index} className='ThemeThreeWebQuickViewCardWrap' dangerouslySetInnerHTML={{ __html: addDataPosition(bodySnippet, index) }}></div>
                        }
                      }
                    }
                    else {
                      if (props.adNetwork === "google" && index === 2) {
                        return <div key={'0_' + index} className='ThemeThreeWebQuickViewCardWrap'>{insertAdSlot(index, bodySnippet, props.name)}</div>
                      } else if (props.adNeThreerk === "can") {
                        if ((index + 1) % 4 === 3) {
                          return <div key={'0_' + index} className='ThemeThreeWebQuickViewCardWrap'>{insertAdSlot(index, bodySnippet, props.name)}</div>
                        }
                      }
                    }
                  }
                  return <div key={'Qitem_' + index} className='ThemeThreeWebQuickViewCardWrapSlide'>
                    <div className='ThemeThreeWebTrnCardWrap'>
                      <div className='ThemeThreeWebQuickViewCardWrap'>
                        <Link href={itemObj.wu} key={'2_' + index} target="_self" className='ThemeThreeWebQuickViewCardImgWrap'>

                          {isImageSizeBlank(itemObj.imageid) ? <picture>
                            <source media="(min-width: 768px)" srcSet={getImageUrl(itemObj.id, getImageSize(itemObj.imageid), 264, 198, "", false, props.CONSTANTS, '8')} />
                            <source media="(max-width: 767px)" srcSet={getImageUrl(itemObj.id, getImageSize(itemObj.imageid), 264, 198, "", false, props.CONSTANTS, '8')} />
                            <img alt={itemObj?.hl?.slice(0, 25) ?? ''} title={itemObj?.hl?.slice(0, 25) ?? ''} loading="lazy" />
                          </picture> : <img src={GetFallBackImage()} alt={itemObj?.hl?.slice(0, 25) ?? ''} title={itemObj?.hl?.slice(0, 25) ?? ''} loading="lazy"/>}
                          <div className='ThemeThreeWebQuickViewCarContentWrap'>
                            <p className='ThemeThreeAuthorProfile'>{itemObj.cat}</p>
                            <p className='ThemeThreeNameAuthor'>{itemObj.hl}</p>
                            <p className='ThemeThreeAuthorDiscription'>{itemObj.syn}</p>
                          </div>
                        </Link>


                      </div>
                    </div>
                  </div>

                }
                )}
            </Slider>
          </div>
        </div>
      </div>
    </CacheProvider>
  }


  return (
    <>
      {getRenderPart()}
    </>
  );

}
